module.exports = __webpack_public_path__ + "img/transparent-nav-right-hyundai.d78eae6c.png";